import React, { useState } from 'react';
import TipModal from './TipModal';

type Props = {
  toCreatorId: string;
  toCreatorName?: string;
  className?: string;
  defaultAmount?: number;
  currency?: string;
  onSuccess?: (tipId: string) => void;
};

const TipButton: React.FC<Props> = ({ toCreatorId, toCreatorName, className = '', defaultAmount = 5, currency = 'USD', onSuccess }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className={`inline-flex items-center gap-2 px-4 py-2 rounded-md bg-indigo-600 text-white hover:bg-indigo-700 ${className}`}
      >
        <svg className="w-5 h-5" viewBox="0 0 20 20" fill="currentColor"><path d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 18.657l-6.828-6.829a4 4 0 010-5.656z"/></svg>
        Tip
      </button>
      {open && (
        <TipModal
          toCreatorId={toCreatorId}
          toCreatorName={toCreatorName}
          defaultAmount={defaultAmount}
          currency={currency}
          onClose={() => setOpen(false)}
          onSuccess={(id) => { setOpen(false); onSuccess?.(id); }}
        />
      )}
    </>
  );
};

export default TipButton;
